/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'folder': {
    width: 200,
    height: 161.905,
    viewBox: '0 0 200 161.905',
    data: '<g fill-rule="evenodd"><path pid="0" d="M29.334 14.219h-.01c-14.22 0-21.33 5.74-21.33 17.23v91.89c0 11.48 7.11 17.23 21.33 17.23h135.12c14.23 0 21.34-5.75 21.34-17.23v-91.89c0-11.49-7.11-17.23-21.34-17.23H29.334z" _fill="#ebbb5d"/><path pid="1" d="M181.25 29.98c10.36 0 18.75 8.06 18.75 17.99v95.95c0 9.93-8.39 17.98-18.75 17.98H18.75C8.39 161.9 0 153.85 0 143.92V17.99C0 8.05 8.39 0 18.75 0h54.61c8.37 0 15.73 5.33 18.03 13.05l5.04 16.93h84.82z" _fill="#ffd977"/></g>'
  }
})
